export default __webpack_public_path__ + "static/media/landingImage.8189f39a.png";